import React, { useEffect, useState } from "react";
import {
  BoldLgPri,
  HorizontalLeftAlign,
  RegSmPri,
  SpaceBetween,
  VerticalAlign,
  VerticalLeftAlign,
} from "../CustomStyles";
import MasKInput from "../IconInputField";
import IconButton from "../IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Colors from "../../Constant/Colors";
import { useDispatch, useSelector } from "react-redux";
import { postQuizRequest, postSubmitQuizRequest } from "../../Redux/actions/home";
import { Title } from "./styles";

const QuizComponent = ({ course, closeModal, quiz }) => {
  const dispatch = useDispatch();
  const { isInstructor } = useSelector((state) => state.auth);
  const { quizLoading } = useSelector((state) => state.home);
  
  const [count, setCount] = useState(1);
  const [score, setScore] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [extra, setExtra] = useState(false);
  const [quizData, setQuizData] = useState({
    course_id: course?.id,
    title: "",
    question: [],
  });
  const [newQuizQuestions, setNewQuizQuestions] = useState([
    {
      label: "",
      order: 0,
      answers: [],
    },
  ]);
  const [newQuizOptions, setNewQuizOptions] = useState([
    { text: "", correct: false, order: 0 },
  ]);

  const enterQuestion = (e) => {
    newQuizQuestions[count - 1].label = e;
    setExtra(!extra);
  };
  const enterOption = (e, i) => {
    newQuizOptions[i].text = e;
    setExtra(!extra);
  };
  const updateQuizData = (key, value) => {
    setQuizData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const previousQuestion = () => {
    if (isInstructor) {
      if (count > 1) {
        let opt = newQuizQuestions[count - 2].answers;
        setNewQuizOptions(opt);
        setCount(count - 1);
      }
    } else {
      setCount(count - 1);
      let arr = [...newQuizOptions]
      let isCorrect = arr.some(s => s.correct && s.selectedOption)
      if (isCorrect) setScore(score - 1)

    }
  };
  const nextQuestion = () => {
    if (isInstructor) {
      if (
        newQuizQuestions[count - 1].label &&
        newQuizOptions[newQuizOptions.length - 1].text &&
        isCorrectAnswer
      ) {
        setCount(count + 1);
        newQuizQuestions[count - 1].answers = newQuizOptions;
        // console.log(newQuizQuestions, count, newQuizQuestions[count + 1]);
        if (!newQuizQuestions[count] && !newQuizQuestions[count]?.label) {
          setNewQuizOptions([{ text: "", correct: false, order: 0 }]);
          let obj = {
            label: "",
            answers: [],
            order: count,
          };
          setNewQuizQuestions((prev) => [...prev, obj]);
        } else {
          setNewQuizOptions(
            newQuizQuestions[count]?.answers[0]?.text
              ? newQuizQuestions[count]?.answers
              : [{ text: "", correct: false, order: 0 }]
          );
        }
      }
    } else {
      if (count < newQuizQuestions.length) setCount(count + 1);
      let arr = [...newQuizOptions];
      let isCorrect = arr.some((s) => s.correct && s.selectedOption);
      if (isCorrect) setScore((prevScore) => prevScore + 1);
    }
  };

  const handleCorrectAnswer = (ind) => {
    setNewQuizOptions((prevOptions) => {
      return prevOptions.map((option, i) => {
        if (isInstructor) {
          if (i === ind) {
            return { ...option, correct: true };
          } else {
            return { ...option, correct: false };
          }
        } else {
          if (i === ind) {
            return { ...option, selectedOption: true };
          } else {
            return { ...option, selectedOption: false };
          }
        }
      });
    });
  };
  const handleDeleteOpt = (id) => {
    if (newQuizOptions.length > 1) {
      let arr = [...newQuizOptions];
      arr = arr.filter((f, i) => i !== id);
      setNewQuizOptions(arr);
    }
  };

  const nextOption = () => {
    let obj = { text: "", correct: false, order: newQuizOptions.length };
    setNewQuizOptions((prev) => [...prev, obj]);
  };
  const isCorrectAnswer = isInstructor
    ? newQuizOptions.some((f) => f.correct)
    : newQuizOptions.some((f) => f.selectedOption);

  const getBackgroundColor = () => {
    if (isInstructor) {
      if (
        newQuizQuestions[count - 1]?.label &&
        newQuizOptions[newQuizOptions.length - 1]?.text &&
        isCorrectAnswer
      ) {
        return Colors.btnPrimary;
      } else {
        return Colors.disabled;
      }
    } else {
      if (newQuizQuestions.length !== count && isCorrectAnswer) {
        return Colors.btnPrimary;
      } else {
        return Colors.disabled;
      }
    }
  };

  const customStyles = {
    delIcon: {
      marginLeft: isInstructor ? 20 : 10,
      marginRight: isInstructor ? 10 : 10,
      width: 25,
    },
    checkbox: {
      width: 20,
      height: 20,
      marginLeft: 10,
      marginRight: 10,
    },
    checkboxTxt: {
      fontSize: 8,
      color: Colors.lightTxt,
      marginTop: -5,
    },
    btn2: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
    },
    prevBtn: {
      width: "90%",
      backgroundColor: count === 1 ? Colors.disabled : Colors.btnPrimary,
    },
    nextBtn: isInstructor => ({
      width: isInstructor ? "90%" : '100%',
      backgroundColor: getBackgroundColor(),
    }),
  };


  const submitQuiz = () => {
    let ind = newQuizQuestions.findIndex((f) => !f.label || !f.answers.length);

    if (ind !== -1) delete newQuizOptions[ind];
    let data = {
      course_id: course?.id,
      title: quizData.title,
      questions: newQuizQuestions,
    };

    dispatch(postQuizRequest(data))
    // console.log("data", data, JSON.stringify(data, null, 8));
  };

  const submitQuizAnswers = () => {
    let scored = Math.round(score / newQuizQuestions.length * 100)
    let data = {
      course_id: course?.id,
      quiz_id: quiz?.id,
      score: scored,
    };

    dispatch(postSubmitQuizRequest(data))
  };
  // console.log("submitQuizAnswers", score, newQuizOptions);

  const subQuiz = () => {
    nextQuestion();
    if (isInstructor) {
      submitQuiz();
    } else {
      setIsSubmitting(true);
    }
    setTimeout(() => {
      closeModal();
    }, 1000);
  };

  useEffect(() => {
    if (quiz?.question) {
      setNewQuizQuestions(quiz?.question);
    }
  }, [quiz]);

  useEffect(() => {
    if (quiz?.question) {
      let arr = quiz?.question[count - 1].answer;
      arr.forEach((fe) => (fe.selectedOption = false));
      setNewQuizOptions(arr);
    }
  }, [count]);
  useEffect(() => {
    if (isSubmitting) {
      submitQuizAnswers();
    }
  }, [isSubmitting]);

  return (
    <Title>
      {/* --------------- Quiz Title ----------------- */}
      <MasKInput
        text={"Quiz Title"}
        placeholder={"Enter Quiz Title"}
        value={isInstructor ? quizData.title : quiz?.quiz_title}
        readOnly={!isInstructor}
        name="title"
        onChangeText={(a, e) => updateQuizData("title", e)}
      />
      {/* --------------- Question # ----------------- */}
      <BoldLgPri>Total Questions: {newQuizQuestions.length}</BoldLgPri>
      {/* <BoldLgPri>Total score: {score} out of {newQuizQuestions.length} in percentage {Math.round(score / newQuizQuestions.length * 100)}</BoldLgPri> */}
      <BoldLgPri>Question # {count}</BoldLgPri>
      <MasKInput
        placeholder={"Enter Question"}
        value={
          isInstructor
            ? newQuizQuestions[count - 1].label
            : quiz?.question[count - 1].label
        }
        readOnly={!isInstructor}
        onChangeText={(a, e) => enterQuestion(e)}
      />
      {/* --------------- Options # ----------------- */}
      <BoldLgPri>Options</BoldLgPri>
      {newQuizOptions.map((opt, i) => (
        <HorizontalLeftAlign
          style={{
            width: "100%",
            display: "flex",
            flexDirection: isInstructor ? "row" : "row-reverse",
            // justifyContent: isInstructor ? "space-between" : 'flex-end',
          }}
        >
          <MasKInput
            placeholder={`Enter Option # ${i + 1}`}
            value={newQuizOptions[i].text}
            readOnly={!isInstructor}
            onChangeText={(a, e) => enterOption(e, i)}
            mainStyle={{ width: "100%" }}
          />
          <VerticalAlign style={customStyles.delIcon}>
            <input
              type="checkbox"
              checked={
                isInstructor
                  ? newQuizOptions[i].correct
                  : newQuizOptions[i].selectedOption
              }
              onChange={() => handleCorrectAnswer(i)}
              style={customStyles.checkbox}
            />
            {isInstructor && (
              <RegSmPri style={customStyles.checkboxTxt}>Correct</RegSmPri>
            )}
          </VerticalAlign>
          {isInstructor && (
            <VerticalAlign
              style={customStyles.delIcon}
              onClick={() => handleDeleteOpt(i)}
            >
              <DeleteIcon style={{ color: "red" }} />
              <RegSmPri style={customStyles.checkboxTxt}>Delete</RegSmPri>
            </VerticalAlign>
          )}
        </HorizontalLeftAlign>
      ))}
      {/* --------------- Next Options Button # ----------------- */}
      {newQuizOptions.length < 4 && isInstructor && (
        <IconButton text={"Next Option"} onClick={nextOption} />
      )}
      <SpaceBetween style={{ width: "100%" }}>
        {isInstructor && <div style={{ width: "100%" }}>
          <IconButton
            text={"Previous Question"}
            onClick={previousQuestion}
            style={customStyles.prevBtn}
          />
        </div>}
        <div style={customStyles.btn2}>
          <IconButton
            onClick={nextQuestion}
            text={"Next Question"}
            style={customStyles.nextBtn(isInstructor)}
            disabled={
              !newQuizQuestions[count - 1].label ||
              !newQuizOptions[newQuizOptions.length - 1]?.text ||
              !isCorrectAnswer ||
              (!isInstructor && newQuizQuestions.length === count)
            }
          />
        </div>
      </SpaceBetween>
      {
        <IconButton
          text={"Submit Quiz"}
          onClick={subQuiz}
          disabled={
            isInstructor
              ? !newQuizQuestions[count - 1].label ||
              !newQuizOptions[newQuizOptions.length - 1]?.text ||
              !isCorrectAnswer
              : newQuizQuestions.length !== count || !isCorrectAnswer
          }
          loading={quizLoading}
        />
      }
    </Title>
  );
};

export default QuizComponent;
